export default "__VITE_ASSET__C0XmERIK__ 480w, __VITE_ASSET__bl1DHd2E__ 768w, __VITE_ASSET__FcSrbRVW__ 1200w, __VITE_ASSET__5dNPJrw___ 1600w";